<h2>{{ "medication.found_medication_incidents.steps.summary.title" | translate }}</h2>

@if (medicationIncident) {
	<div class="card border-1-solid-grey" data-test="medication-incident-summary">
		<dl>
			<dt>{{ "medication.found_medication_incidents.steps.summary.date" | translate }}</dt>
			<dd data-test="summary-incident-date">
				{{ formatDateTime(medicationIncident.foundIncidentDate) }}
			</dd>

			<dt>{{ "medication.found_medication_incidents.steps.summary.incidentType" | translate }}</dt>
			<dd data-test="summary-incident-type">
				{{ "medication.found_medication_incidents.incident_type" | translate }}
			</dd>

			<dt>{{ "medication.found_medication_incidents.steps.summary.location" | translate }}</dt>
			<dd data-test="summary-incident-location">
				{{ getLocationDescription(medicationIncident.location) }}
			</dd>

			<dt>{{ "medication.found_medication_incidents.steps.summary.medication" | translate }}</dt>
			@for (detail of medicationIncident.details; track detail) {
				<div data-test="summary-details">
					@if (detail.medication.type === MedicationType.UNKNOWN) {
						<dd>
							<p data-test="summary-unknown-medication-description">
								{{ detail.medication.description }}
							</p>
							<p data-test="summary-unknown-medication-quantity">
								{{ "medication.found_medication_incidents.steps.summary.quantity" | translate }}: {{ detail.quantity }}
							</p>
						</dd>
					} @else {
						<dd>
							<p data-test="summary-known-medication-code">
								{{ detail.medication.name | language }} ({{ detail.medication.code }})
							</p>
							<p data-test="summary-known-medication-quantity">
								{{ "medication.found_medication_incidents.steps.summary.quantity" | translate }}: {{ detail.quantity }}
							</p>
						</dd>
					}
				</div>
			}
		</dl>
	</div>
}
